import { z } from 'zod'
import { withValidate } from 'lib/zod-validate'
import {isValidDateTime} from 'utils/formValidation'

export const reminderSchema = withValidate(z.object({
    model_id: z.number().int().nullable().optional(),
    model_name: z.string().trim().min(1, 'Model name is required'),
    type: z.string().trim().min(1, 'Type is required'),
    hall_id: z.number().int().positive('Hall is required'),
    seller_id: z.number().int().positive('Seller is required'),
    interval: z.number().int().nullable().optional(),
    content: z.string().trim().min(1, 'Content is required').max(2000, 'Content must be at most 2000 characters'),
    due_at: z.string().trim().min(1, 'Due date is required').refine(isValidDateTime, 'Enter a valid due date'),
    expires_at: z.string().trim().refine(value => value === '' || isValidDateTime(value), 'Enter a valid expiry date').nullable().optional(),
}))

export type ReminderRequest = z.infer<typeof reminderSchema>
